import {HighlighterTool} from '@modules/whiteboard/shapes/highlighter'
import {LineTool} from './LineTool'
import { ArrowTool } from './ArrowTool'
import {TDToolType } from '@modules/whiteboard'
import { DrawTool } from './DrawTool'
import { EllipseTool } from './EllipseTool'
import { RectangleTool } from './RectangleTool'
import { SelectTool } from './SelectTool'
import { StickyTool } from './StickyTool'
import { TextTool } from './TextTool'
import { EraseTool } from './EraseTool'
export * from './BaseTool'
import { FrameTool } from './FrameTool'
export * from './FrameTool'
export {SelectTool, ArrowTool, EraseTool, TextTool, RectangleTool, EllipseTool, DrawTool, StickyTool, LineTool}
export * from './OptionalShapeTitle'

export interface ToolsMap {
  select: typeof SelectTool
  erase: typeof EraseTool
  text: typeof TextTool
  draw: typeof DrawTool
  ellipse: typeof EllipseTool
  rectangle: typeof RectangleTool
  line: typeof LineTool
  arrow: typeof ArrowTool
  sticky: typeof StickyTool
  frame: typeof FrameTool
  highlighter: typeof HighlighterTool
}

export interface ToolInstancesMap {
  select: SelectTool
  erase: EraseTool
  text: TextTool
  draw: DrawTool
  ellipse: EllipseTool
  rectangle: RectangleTool
  line: LineTool
  arrow: ArrowTool
  sticky: StickyTool
  frame: FrameTool
  highlighter: HighlighterTool
}
export type ToolOfType<K extends TDToolType> = ToolsMap[K]

export type ArgsOfType<K extends TDToolType> = ConstructorParameters<ToolOfType<K>>

export const tools: { [K in TDToolType]: ToolsMap[K] } = {
  select: SelectTool,
  erase: EraseTool,
  text: TextTool,
  draw: DrawTool,
  ellipse: EllipseTool,
  rectangle: RectangleTool,
  line: LineTool,
  arrow: ArrowTool,
  sticky: StickyTool,
  frame: FrameTool,
  highlighter: HighlighterTool
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/index.ts